export default "__VITE_PUBLIC_ASSET__68b01c89__"